export default __webpack_public_path__ + "static/char-s-37-ko-a97ab1e1f16d4820ff3d4c23b95058e5.png";